module.exports = __webpack_public_path__ + "static/logo_tena-ecf2652669ea674be6b02170b0013761.webp";